module.exports = __webpack_public_path__ + "img/Thermo .d7fe1e70.svg";